import { Button, Typography } from '@kar-dmp/ignite';
import PublicLayout from 'components/PublicSiteLayout/Base';
import { redirect } from 'helpers/redirect';
import ErrorImage from './ErrorImage';

const OpenlaneError = ({ statusCode, title, description, hideButton }) => (
	<PublicLayout>
		<div className="flex justify-center p-[60px] max-md:p-[10px]">
			<div className="z-[2] flex h-fit w-[640px] flex-col items-center rounded-2xl bg-white p-[40px] shadow-md max-md:w-auto max-md:p-[10px]">
				<div className="flex max-w-[432px] flex-col items-center">
					{Boolean(statusCode) && <ErrorImage statusCode={statusCode} />}
					<Typography variant="h2" className="p-5 text-center">
						{title}
					</Typography>
					<Typography className="text-center">{description}</Typography>
					{!hideButton && (
						<div className="flex items-center justify-center p-6">
							<Button size="lg" onClick={() => redirect('/')}>
								Back to OPENLANE
							</Button>
						</div>
					)}
				</div>
			</div>
		</div>
	</PublicLayout>
);

export default OpenlaneError;
